const ID = {
  Home: "Beranda",
  Information: "Informasi",
  Dashboard: "Dasbor",
  "Information Dashboard": "Dasbor Informasi",
  "Expected Earnings": "Pendapatan yang diharapkan",
  Daily: "Harian",
  Week: "Minggu",
  Month: "Bulan",
  "Daily Sales": "Penjualan Harian",
  "Sales Name": "Nama Sales",
  "Sales This Months": "Penjualan bulan ini",
  Orders: "Pesanan",
  "Orders This Week": "Pesanan minggu ini",
  to: "ke",
  Goal: "Target",
  "to Goal": "ke Target",
  New: "Baru",
  "New Customers This Month": "Pelanggan baru minggu ini",
  Active: "Aktif",
  "Active Sales": "Sales Aktif",
  "Recent Orders": "Pesanan Terbaru",
  "Item Name": "Nama Barang",
  "Discount Sales": "Diskon Penjualan",
  "Total Discounted Sales This Month": "Total Diskon Penjualan Bulan Ini",

  Utility: "Utilitas",
  List: "Daftar",
  Hierarchy: "Hirarki",
  Setup: "Pengaturan",
  Warehouse: "Gudang",
  "Warehouse Mutation": "Mutasi Gudang",
  "Setup Warehouse": "Pengaturan Gudang",
  "Sub Warehouse": "Sub Gudang",
  SubWarehouse: "Sub Gudang",
  Supplier: "Pemasok",
  "Supplier List": "Daftar Pemasok",
  "Supplier Name": "Nama Pemasok",
  Taking: "Pengambilan",

  Customer: "Pelanggan",
  Customers: "Pelanggan",
  Type: "Tipe",
  "Customer Type": "Tipe Pelanggan",
  "Customer List": "Daftar Pelanggan",
  "Customer Hierarchy": "Hirarki Pelanggan",
  "Setup Hierarchy": "Pengaturan Hirarki",
  Code: "Kode",
  "Code Customer": "Kode Pelanggan",
  "Code Branch": "Kode ASMO",
  "Customer Code": "Kode Pelanggan",
  Branch: "ASMO",
  "Branch Name": "ASMO",
  "Branch List": "Daftar ASMO",
  Store: "Depo",
  "Store List": "Daftar Depo",
  Payment: "Pembayaran",
  "Payment Type": "Tipe Pembayaran",
  Address: "Alamat",
  Province: "Provinsi",
  City: "Kota",
  District: "Kecamatan",
  "Sub District": "Kelurahan",
  "Long Business": "Lama Usaha",
  Phone: "Telepon",
  "ID Number": "No KTP",
  "Contact Person": "Kontak Person",
  "Contact Person Phone": "Telepon CP",
  Tax: "Pajak",
  "Tax Status": "Status Pajak",
  "Tax List": "Datar Pajak",
  Competitors: "Kompetitor",
  Item: "Barang",
  "Selling (Pack)": "Penjualan (Pack)",
  "Selling Price": "Harga Jual",
  "Turnover/Week": "Omzet/Minggu",
  "Invoice Limit": "Limit Nota",
  "Credit Limit": "Limit Kredit",
  Note: "Catatan",

  Value: "Nilai",
  Parent: "Induk",
  "Warehouse Parent": "Gudang Utama",
  "Warehouse List": "Daftar Gudang",

  Unit: "Satuan",
  "Unit List": "Daftar Satuan",
  Brand: "Merk",
  "Item Brand": "Merk",
  "Item Brand List": "Daftar Merk",
  "Brand Item": "Merk",
  Category: "Kategori",
  "Item Category": "Kategori",
  "Item Category List": "Daftar Kategori",
  "Category Item": "Kategori",
  "Item Type": "Tipe",
  "Type Item": "Tipe",
  Account: "Akun",
  Inventory: "Persediaan",
  "Inventory Account": "Akun Persediaan",

  "Item List": "Daftar Barang",
  User: "Pengguna",
  "User Assignment": "Penugasan Pengguna",
  Assignment: "Penugasan",
  Route: "Rute",
  Roles: "Peran",
  Role: "Peran",
  "Name User": "Nama Pengguna",
  "Set Assignment": "Pengaturan",
  "Update User": "Edit",
  "Delete User": "Hapus",
  "Block User": "Blokir",
  "Assignment Choosed": "Penugasan yang Dipilih",

  "Approval Transaction": "Persertujuan Transaksi",
  "Type Transaction": "Tipe Transaksi",
  "Approval Goods Offer": "Penawaran",
  "Approval Memo In": "Memo In",
  "Approval Memo Out": "Memo Out",
  "Approval Purchase Order": "Pesanan Pembelian",
  "Approval Return Price": "Harga Retur",
  "Approval Return Selling": "Retur Penjualan",
  "Approval Selling Price": "Harga Jual",
  "Approval Taking Goods": "Pengambilan Barang",

  Name: "Nama",
  Created: "Dibuat",
  at: "Oleh",
  "Created at": "Dibuat Oleh",
  "Updated at": "Diperbarui Oleh",
  Updated: "Diperbarui",

  All: "Semua",
  Active: "Aktif",
  Non: "Tidak",
  "Non Active": "Tidak Aktif",

  Add: "Tambah",
  "Add Customer Type": "Tambah Tipe",
  "Add Customer": "Tambah Pelanggan",
  "Add Competitors": "Tambah Komeptitor",
  "Add Setup Hierarchy": "Tambah Pengaturan",
  "Add Warehouse": "Tambah Gudang",
  "Add Supplier": "Tambah Pemasok",
  "Add Unit": "Tambah Satuan",
  "Add Brand Item": "Tambah Merk",
  "Add Category Item": "Tambah Kategori",
  "Add Type Item": "Tambah Tipe",
  "Add Item": "Tambah Barang",
  "Add Role": "Tambah Peran",
  "Add Branch": "Tambah ASMO",
  "Add Store": "Tambah Depo",
  "Add Tax": "Tambah Pajak",
  "Add Offering": "Tambah Penawaran",
  "Add Purchase Request": "Tambah Permintaan",
  "Add Details": "Tambah Barang",
  "Add Quotation": "Tambah Penawaran",
  "Add Purchase Order": "Tambah Pesanan",
  "Add Taking Goods": "Tambah Pengambilan",
  "Add Receiving": "Tambah Penerimaan",
  "Add Acceptance Report": "Tambah BA",
  "Add Invoice": "Tambah Faktur",
  "Add Warehouse Out": "Tambah Data",
  "Add Warehouse In": "Tambah Data",
  "Add Task": "Tambah Aktifitas",
  "Add Schedule": "Tambah Jadwal",
  Save: "Simpan",
  Close: "Tutup",
  Action: "Aksi",
  Edit: "Ubah",
  "Edit Config Branch": "Ubah Konfigurasi",
  Delete: "Hapus",
  View: "Lihat",
  "Show": "Tampilkan",
  Print: "Cetak",
  "Convert":"Tampilkan",
  "Choose File": "Pilih Dokumen",
  Select: "Pilih",
  "Select...": "Pilih",
  "Select Branch": "Pilih ASMO",
  "Select Store": "Pilih Depo",
  "Select Type Customer": "Pilih Tipe",
  "Select Type": "Pilih Tipe",
  "Select Province": "Pilih Provinsi",
  "Select City": "Pilih Kota",
  "Select District": "Pilih Kecamatan",
  "Select Sub District": "Pilih Kelurahan",
  "Select Customer Type": "Pilih Tipe",
  "Select Warehouse": "Pilih Gudang",
  "Select Sub Warehouse": "Pilih Sub Gudang",
  "Select Parent": "Pilih Satuan Utama",
  "Select Account": "Pilih Akun",
  "Select Account COA": "Pilih Akun",
  "Select Supplier": "Pilih Pemasok",
  "Select Item": "Pilih Barang",
  "Select Item Type": "Pilih Tipe Barang",
  "Select Unit": "Pilih Satuan",
  "Select Sales": "Pilih Sales",
  "Select Sales Order": "Pilih Pesanan",
  "Select/Create The Supplier": "Pilih/Tambah Pemasok",
  "Select Week": "Pilih Week",

  "Upload Files (max 3 items)": "Unggah Dokumen (Maks 3 item)",
  Cash: "Tunai",
  Credit: "Kredit",
  Supervisior: "Supervisor",

  "Sales Order": "Pesanan Penjualan",
  "Quotation Request": "Pengajuan Penawaran",
  "No. Quotation": " No Penawaran",
  "Quote No.": "No Penawaran",
  "you can create the temporary supplier with type the name supplier":
    "Nama pemasok sementara dapat dibuat dengan langsung mengetik nama pemasok",
  "Request List": "Daftar Permintaan",
  "Recap PR": "Rekap Permintaan",
  "Qty Order": "Jumlah Permintaan",
  "Qty Mutation": "Jumlah Mutasi",
  "Qty Request": "Jumlah Permintaan",
  "Set Supplier Request": "Mengatur Pemasok",
  "Mutation Items": "Mutasi Barang",

  "Purchase Order": "Pesanan Pembelian",
  "No Order": "No Pesanan",
  "Tanggal Order": "Tanggal Pesan",
  "Grand Total": "Total",
  Remaining: "Sisa",
  "Nett Price": "Harga Nett",

  "Duration Rest Up (Minute)": "Durasi Istirahat Max (Menit)",
  "Duration Rest Down (Minute)": "Durasi Istirahat Min (Menit)",
  "Tolerance Rest (Minute)": "Toleransi Istirahat (Menit)",
  "Tolerance Checkin (Minute)": "Toleransi Jam Masuk",
  "Tolerance Checkout (Minute)": "Toleransi Jam Pulang",
  "Tolerance Distance (Minute)": "Toleransi Jarak Absen",
  "Check In Time": "Jam Masuk",
  "Check Out Time": "Jam Pulang",
  Timezone: "Zona Waktu",

  Language: "Bahasa",
  "Select Status": "Pilih Status",

  Offering: "Penawaran",
  Receiving: "Penerimaan Barang",
  Mutation: "Mutasi Barang",

  "Purchase Request": "Permintaan Pembelian",
  Date: "Tanggal",
  "Purchase Request No.": "No Permintaan",
  "No. Request": "No Permintaan",

  "Waiting For Approval": "Menunggu Persetujuan",
  Procurement: "Pengadaan",
  "PR Rejected": "Ditolak",
  "PO Rejected": "Order Ditolak",
  "PO Closed": "Order Ditutup",
  "Waiting Center Approval": "Menunggu Persetujuan HO",
  "Waiting Receiving Item": "Menunggu Penerimaan Barang",
  "Waiting For Payment": "Menunggu Pembayaran",
  Done: "Selesai",
  "Warehouse Transfer": "Pindah Gudang",
  Approved: "Disetujui",
  Rejected: "Ditolak",
  "Waiting HO Approval": "Menunggu Persetujuan HO",

  "Taking Goods": "Pengambilan Barang",
  "Return Goods": "Pengembalian Barang",
  "Taking Goods No.": "No Pengambilan",

  "PO No": "No Order",
  "Date PO": "Tanggal Order",
  "Date Delivery": "Tanggal Kirim",
  "Discount Percent": "Diskon (%)",
  "Discount (Rp)": "Diskon (Rp)",
  Price: "Harga",
  "Price Nett": "Harga",
  "Price Total": "Total Harga",
  Total: "Total",
  "Total Price": "Total Harga",
  "Total Discount": "Total Diskon",
  "Total Tax": "Total Pajak",
  "Code Item": "Kode Barang",
  "Item Code": "Kode Barang",

  "No PO": "No Order",
  "Band No": "Banderol",
  Reamining: "Remaining Qty",
  Qty: "Jumlah",
  "Receiving (PB)": "Goods Receipt",
  "No. PB": "Receiving No.",
  "No. Band": "Pita",
  Description: "Keterangan",
  "Document No": "No Dokumen",
  "Delivery Date": "Tanggal Pengiriman",

  "Config Name": "Nama Konfigurasi",
  "Config Branch": "Konfigurasi ASMO",
  Configuration: "Konfigurasi",
  Persentage: "Persentase",
  accSetup: "Pilih Akun",
  "Effective Date": "Tanggal Efektif",
  Purchasing: "Pembelian",
  Transaction: "Transaksi",
  "Transaction No.": "No Transaksi",
  Order: "Pesanan",
  "Goods Offer": "Penawaran",
  Return: "Kembali",
  "Return Date": "Tanggal Kembali",

  Receipt: "Penerimaan",
  "Goods Receipt": "Penerimaan Barang",
  "Receiveing No.": "No Penerimaan",
  "Receiving No": "No Penerimaan",
  "Receiving Date": "Tanggal Penerimaan",
  "Document No.": "No Dokumen",
  "No Order": "No Pesanan",
  "Qty Received": "Terima",
  "Banderol": "Pita",
  "Batch No": "No Batch",
  "Remaining Qty": "Sisa",

  "Acceptance Report": "Berita Acara",
  "Transaction No": "No Transaksi",

  "Purchase Invoice": "Faktur Pembelian",
  "Invoice No.": "No Faktur",
  "Invoice Date": "Tanggal Faktur",

  "Supplier Payments": "Pembayaran Pemasok",
  "Remaining Payment": "Sisa Tagihan",

  "Warehouse Out": "Gudang Keluar",
  "Warehouse In": "Gudang Masuk",
  "Plate No.": "No Kendaraan",
  Expedition: "Ekspedisi",
  "Origin Warehouse": "Gudang Asal",
  "Destination Warehouse": "Gudang Tujuan",
  "Initial Warehouse": "Gudang Asal",
  "Stock From Purchase Recap": "Dari Permintaan Barang",
  Stock: "Stok",
  "Recceipt No.": "No Transaksi",
  "Qty Sent": "Jumlah Dikirim",

  Stock: "Stok",
  "Stock Movement": "Stok",
  "Stock Trail": "Mutasi Stok",
  "Stock Card": "Kartu Stok",
  "Stock Trail Report": "Mutasi Stok",
  "Date Period": "Periode",
  "Beginning Stock": "Stok Awal",
  "Beginning Balance": "Saldo Awal",
  "Qty In": "Masuk",
  "Balance In": "Saldo Masuk",
  "Qty Out": "Keluar",
  "Balance Out": "Saldo Keluar",
  "Ending Stock": "Stok Akhir",
  "Ending Balance": "Saldo Akhir",
  "Remark": "Keterangan",
  "No Data Found": "Tidak Ada Data",
  "Week Period": "Periode",
  "Period": "Periode",

  "Sales": "Penjualan",
  "Schedule": "Jadwal",
  "Sales Activities": "Aktifitas Sales",
  "Visit Schedule": "Jadwal Kunjungan",
  "Employee": "Sales",
  "Select Employee": "Pilih Sales",
  "Employee Name": "Nama Sales",
  "type": "Tipe",
  "Single Customer": "",

"List Schedule":"Daftar Kunjungan",
"Change Schedule":"Ubah Jadwal",
"Code Sales":"Kode Sales",
"New Schedule":"Jadwal Baru",
"Check In":"Clock In",
"Change Sales":"Sales Diubah",
"Position":"Posisi",
"Select Position":"Pilih Posisi",
"Sales Name Before":"Sales Sebelumnya",
"To":"s/d",
"Change":"Diubah Ke-",
"Sales Name After":"Sales Pengganti",

"Reconcile Cash Sales":"Rekonsiliasi Kas",
"No Journal":"No Transaksi",
"Reconcile":"Rekonsil",
"Not Reconcile":"Belum Rekonsil",
"Invoice Selling Date":"Tanggal Nota",
"Cash/Bank":"Kas/Bank",
"Photo":"Bukti",
"Ledger":"Buku Besar",
"Expense":"Biaya",

"New Customer":"Pelanggan Baru",
"Customer Report":"Laporan Pelanggan",
"Search":"Cari",
"Customer Name":"Nama Pelanggan",
"Owner Name":"Nama Pemilik",
"Visit":"Kunjungan",
"Sales Code":"Kode Sales",

"Marketing":"Pemasaran",
"Add Selling Price":"Tambah Harga",
"Type Customer":"Tipe Pelanggan",
"Effecticve Date":"Tanggal Efektif",

"Return Price":"Harga Retur",
"Add Return Price":"Tambah Harga",
"Program Type":"Tipe Program",
"Add ProgramType":"Tambah Program",
"Marketing Program":"Program Pemasaran",
"Add Marketing":"Tambah Program",
"Name Branch":"ASMO",
"Start Date":"Tanggal Mulai",
"End Date":"Tanggal Akhir",
"Description":"Keterangan",
"Minimum Order":"Qty Minimum",
"Select Program Type":"Pilih Tipe",
"Free Item":"Barang Gratis",
"Select Free Item":"Pilih Barang",
"Discount Price":"Potongan Harga",

"Sales Target":"Target Penjualan",
"Info Distribution":"Info Distribusi",
"Add Info Distribution":"Tambah Info",
"Code":"Kode",
"Select Target":"Pilih Target",
"Add Sales Target":"Tambah Target",
"Name Target":"Target",
"Target Name":"Target",
"Select Period":"Pilih Tanggal",
"Sales Assignment":"Target Assignment",
"Position Name":"Jabatan",

"Sales Return":"Retur Penjualan",
"Order Date":"Tanggal DO",
"Sales Order No.":"No. Pesanan",
"Select Name Customer":"Pilih Pelanggan",
"Select Customer":"Pilih Pelanggan",

"Sales Invoice":"Faktur Penjualan",
"Add Sales Invoice":"Tambah Faktur",
"Customer Name":"Nama Pelanggan",
"Cash/Transfer":"Tunai",
"Cash/Bank Account":"Akun Kas/Bank",
"Due Date":"Jatuh Tempo",
"Unit Price":"Harga/Unit",
"Discount Rate":"Diskon (%)",
"Discount Price":"Diskon (Rp)",
"Discount Total":"Total Diskon",
"Tax Total":"Total Pajak",
"Down Payment":"Uang Muka",

"Customer Payments":"Pembayaran Pelanggan",
"Payment Selling":"Pembayaran Penjualan",
"No Invoice":"No Faktur",
"Invoice Selling No":"No Faktur",
"Invoice No":"No Faktur",
"Total Payment":"Total Pembayaran",
"Total Remaining":"Sisa Tagihan",
"Total Bill":"Total Tagihan",
"Refund":"Kembali",

"Billing":"Penagihan",
"Add Billing":"Tambah Penagihan",
"Billing No.":"No Penagihan",
"Total Invoice":"Total Faktur",
"Billing Date":"Tanggal Penagihan",
"Payment Date":"Tanggal Pembayaran",
"Payment No.":"No Pembayaran",
"Customer Name : ":"Pelanggan : ",
"Type Payment":"Tipe Pembayaran",
"Sub Total Bill":"Sub Total Tagihan",
"Cash":"Tunai",

"Payment Confirmation":"Konfirmasi Pembayaran",
"Payment No.":"No Pembayaran",
"Remaining Invoice":"Sisa Tagihan",

"Settlement Sales":"Sales Settlement",
"No. Trasaction":"No Transaksi",
"Name Sales":"Sales",
"Name Customer":"Pelanggan",

"Report":"Laporan",
"Sales Report":"Penjualan",
"Sales Invoice Report":"Laporan Penjualan",
"Period Date":"Periode",
"Branch":"ASMO",
"Show":"Tampilkan",
"Unit Name":"Satuan",
"Disc (Rp.)":"Disk (Rp.)",
"Tax (Rp.)":"Pajak (Rp.)",

"Sales by Customer":"Penjualan per Pelanggan",
"Customer":"Pelanggan",
"Total Purchase":"Total Penjualan",
"AR Aging":"Usia Piutang",
"Paid":"Lunas",
"Unpaid":"Belum Lunas",
"Transaction Date":"Tanggal Transaksi",
"Discount":"Diskon",

"Sales by Item":"Penjualan per Barang",
"Item":"Barang",
"Price (New)":"Harga (Terbaru)",
"Average Price":"Harga Rata-Rata",

"Sales Full":"Penjualan",
"Search":"Cari",
"Invoice no.":"No Faktur",
"Invoice No.":"No Faktur",
"Sales Name":"Sales",
"Date":"Tanggal",
"Sales Order No.":"No Pesanan",
"Payment":"Pembayaran",
"Remaining":"Sisa",

"Sales Performance":"Performa Sales",
"Sales Performance Chart":"Chart Penjualan",
"Weekly":"Mingguan",
"Monthly":"Bulanan",
"Quantity":"Kuantitas",
"Revenue":"Pendapatan",
"Generate":"Tampilkan",
"Total Selling":"Total Penjualan",
"Average Selling":"Rata-Rata Penjualan",

"Sales Performance View":"Penjualan per Sales",
"Sales Performance Daily Monitor":"Monitor Harian",
"Daily Monitor":"Monitor Harian",
"Day":"Hari",
"District":"Kecamatan",
"Total Sales (Qty)":"Total Penjualan (Qty)",
"Total Sales (Rp.)":"Total Penjualan (Rp.)",
"Sales Performance Target":"Pencapaian Target",

"Sales Performance Distribution":"Info Distribusi",
"Info Distribution Sales":"Info Distribusi",

"Customer Performance":"Performa Pelanggan",
"Customer Performance Show":"Performa Pelanggan",
"Branch Must Be Select, Please Choose":"ASMO harus diisi",
"Type Customer Must Be Select, Please Choose":"Tipe harus diisi",
"Customer Performance Chart":"Chart Pembelian",
"Customer Performance Semua":"Chart Pembelian",
"Name Item":"Nama Barang",

"Visiting Sales":"Kunjungan Sales",
"Report Visit Sales":"Kunjungan Sales",
"Export to Excel":"Ekspor ke Excel",
"Timeline":"Jadwal",
"Status Selling":"Info Distribusi",
"Schedule visit to customer : ":"Kunjungan ke:",

"Tracking Sales":"Pelacakan Penjualan",
"Branch Must Be Fill":"ASMO harus diisi",
"No. Purchase Request":"No Pesanan",
"No. Sales Order":"No Pesanan",
"Invoice":"Faktur",
"Not Have Information About Delivery Order !":"Belum ada data",
"Not Have Information About Invoice !":"Belum ada data",
"Not Have Information About Payment!":"Belum ada data",

"Price Comparison Report":"Perbandingan Harga",
"Price Comparison":"Perbandingan Harga",
"Price Comparison Purchasing":"Pembelian",
"Please Wait":"Mohon Tunggu",
"Price Comparison Selling":"Penjualan",

"Accounting":"Akuntansi",
"COA":"Klasifikasi Rekening",
"Add Coa1":"Tambah Rekening",
"ID COA 1":"Kode Level 1",
"Debt":"Debit",
"Credit":"Kredit",
"Balance Sheet":"Neraca Saldo",
"Income Statement":"Laba Rugi",
"ACC1 ID":"Kode Level 1",
"ACC1 Name":"Nama Akun",
"Cash Budget":"Kas Budget",
"Budget List":"Daftar Anggaran",
"Budget":"Anggaran",
"Budget Name":"Nama Anggaran",
"Add Budget":"Tambah Anggaran",
"Add Coa2":"Tambah Rekening",
"ID COA 2":"Kode Level 2",
"ACC2 ID":"Kode Level 2",
"ACC2 Name":"Nama Akun",
"Select COA 1":"Pilih Kode Level 1",

"Add Coa3":"Tambah Rekening",
"ID COA 3":"Kode Level 3",
"Date Cut Off":"Tanggal Cut Off",
"Balance":"Saldo Awal",
"ACC3 ID":"Kode Level 3",
"ACC 3 Name":"Nama Akun",
"Select COA 2":"Pilih Kode Level 2",

"ID COA 4":"Kode Level 4",
// "COA 3":"Level 3",
"ID COA 5":"Kode Level 5",
"Accumulate":"Akumulasi",
"Date Purchased":"Tanggal Pembelian",

"Add Beginning Balance":"Tambah Saldo",
"Select COA 3":"Pilih Kode Level 3",
"Select COA 4":"Pilih Kode Level 4",

"Accounting Setup":"Pengaturan Akuntansi",
"Ledger":"Buku Besar",
"Clarification":"Klasifikasi",

"Asset":"Aset",
"Asset Type":"Tipe Aset",
"Depreciation":"Lama Penyusutan",
"Depreciation Per Month":"Penyusutan Per Bulan",
"Add Asset Type":"Tambah Aset",
"Asset Account":"Akun Aset Tetap",
"Asset Depreciation":"Aset Disusutkan",
"Debt Account":"Akun Debit",
"Credit Account":"Akun Kredit",
"Asset Name":"Nama Aset",
"Account Name":"Akun Aset Tetap",
"Journal Debt":"Akun Debit",
"Journal Credit":"Akun Kredit",

"Asset List":"Daftar Aset",
"Purchase Date":"Tanggal Beli",
"Purchase Price":"Harga Perolehan",
"Accumulation":"Akumulasi Penyusutan",
"Add Asset":"Tambah Aset",
"From Inventory":"Dari Persediaan",
"Depreciation Date":"Mulai disusutkan",

"Cash/Bank":"Kas/Bank",
"Cash Masuk / Keluar":"Kas Masuk / Keluar",
"Incoming":"Masuk",
"Out":"Keluar",

"Cash Bank Book":"Buku Kas/Bank",
"Cash Bank":"Buku Kas/Bank",
"Cash/Bank Book Report":"Buku Kas/Bank",
"Cash / Bank Name":"Kas/Bank",

"Purchase Return":"Retur Pembelian",
"No. Purchase Return":"No Transaksi",
"Add Purchase Return":"Tambah Retur",
"Date":"Tanggal",
"Return Method":"Metode",
"Return Type":"Tipe Retur",
"Invoice":"Faktur",
"ID Transaction":"No Faktur",
"Select ID":"Pilih Faktur",
"Price total":"Total",
"Qty Return":"Jumlah Kembali",
"Record Last Stock":"Stok Akhir",
"Qty Taking":"Jumlah Ambil",
"Total Return":"Total Kembali",
"Stock Available:":"Stok Tersedia:",

"BG In":"BG Masuk",
"BG Date":"Tanggal BG",
"No. Transaction":"No Transaksi",
"Canceled":"Batal",
"BG Out":"BG Keluar",
"Cash Report":"Laporan Kas",
"Daily Cost Summary":"Rekap Biaya Harian",

"List Payment":"Daftar Pembayaran",
"List Payment Supplier":"Pemasok",
"List Payment Customer":"Pelanggan",
"No. Invoice":"No Faktur",
"No. Payment":"No Pembayaran",

"Add Down Payment":"Tambah Data",
"Selling":"Penjualan",
"Select Cash/Bank Account":"Pilih Akun",
"By Detail":"Detail",
"Select PO":"Pilih Transaksi",
"Source":"Transaksi Asal",
"Total DP":"Total UM",
"Total Used":"Total Terpakai",

"Mutation Down Payment":"Mutasi UM",
"Mutation Deposit":"Mutasi UM",
"Top Up Down Payment Supplier Invoice : ":"Penambahan Uang Muka Supplier No Faktur : ",
"Top Up Down Payment Supplier : ":"Penambahan Uang Muka Supplier : ",
"You Will Delete This Data" : "Anda Akan Menghapus Data Ini",
"Accept":"Setuju",
"Cancel":"Batal",
"General Ledger":"Jurnal Umum",
"Journal":"Jurnal Umum",
"Add Journal":"Tambah Jurnal",
"Journal Date":"Tanggal Jurnal",
"Journal No.":"No Transaksi",
"Helper Book":"Buku Pembantu",
"Ledger (Coa Level 3)":"Buku Besar (COA 3)",
"Helper Book (Coa Level 4)":"Buku Pembantu (COA 4)",
"Total Debt":"Total Debit",
"Total Credit":"Total Kredit",
"Account No":"Nama Akun",
"Customer Performance Sales":"Volume Penjualan Pelanggan",
"No. Journal":"No Transaksi",
"Journal Closed":"Tutup Buku",
"Void":"Batal",
"Please Wait ...." : "Mohon Tunggu ....",
"Delete Data":"Hapus Data",
"Add Memo In":"Tambah Memo",
"General Ledger Acc":"Buku Besar",
"Select Ledger":"Pilih Akun",
"Subsidiary Ledger Acc":"Buku Pembantu",
"Select Helper Book":"Pilih Akun",
"No Batch":"Batch No",
"Add Return Goods":"Tambah Pengembalian",
"Week ":"Minggu Ke- ",

"Add Memo Out":"Tambah Memo Out",
"Are you sure?":"Apa Anda Yakin?",
"Closebook":"Tutup Buku",
"Year":"Tahun",
"Select Year":"Pilih Tahun",
"Select Month":"Pilih Bulan",
"Open Closebook":"Buka Transaksi",

"Uncollected Receivables":"Piutang Belum Tertagih",
"Uncollected Debt":"Hutang Belum Tertagih",
"Uncollected Debt Report":"Hutang Belum Tertagih",

"Account Payable":"Hutang Usaha",
"AP Report":"Hutang Usaha",
"AP Card":"Kartu Hutang",
"Debt ":"Hutang",
"Receivables":"Piutang",

"Account Receiveable":"Piutang Usaha",
"AR Report":"Piutang Usaha",
"AR Card":"Kartu Piutang",

"Select Coa3":"Pilih Akun",
"COA Level 3 Must Be Fill":"COA Level 3 Harus Diisi",
"Back":"Kembali",
"Journal Transaction":"Transaksi",

"Work Sheet":"Neraca Lajur",
"Work Sheet Report":"Neraca Lajur",
"Code":"Kode",
"COA Name":"Nama Akun",
"Beginning Debt":"Saldo Awal Debit",
"Beginning Credit":"Saldo Awal Kredit",
"Ending Debt":"Saldo Akhir Debit",
"Ending Credit":"Saldo Akhir Kredit",
"Summary":"Ringkasan",
"Total Awal Debt":"Total Awal Debit",
"Total Awal Credit":"Total Awal Kredit",
"Total Akhir Debt":"Total Akhir Debit",
"Total Akhir Credit":"Total Akhir Kredit",

"Income Statement Report":"Laba Rugi",
"Display":"Tampilkan",
"Please Select a Month":"Harap Pilih Bulan",
"Please Select a Year":"Harap Pilih Tahun",
"This Month":"Bulan Berjalan",
"Total Income Statement":"Laba (Rugi) Bersih",

"Balance Sheet Report":"Neraca Saldo",
"Amount":"Nilai",

"Cash Flow":"Arus Kas",
"Cash Flow Report":"Arus Kas",
"Income":"Pendapatan",
"Total Income":"Total Pendapatan",
"Expenditure":"Pengeluaran",
"Total Expenditure":"Total Pengeluaran",

"Asset Report":"Aset Tetap",
"Accumulated Depreciation":"Akumulasi Penyusutan",
"Depreciation (Month)":"Penyusutan",
"Book Value":"Nilai Buku",

"Human Resource":"Tenaga Kerja",
"Division":"Divisi",
"Add Division":"Tambah Divisi",

"Add Position":"Tambah Posisi",
"Add Category Employee":"Tambah Kategori",

"Employee List":"Daftar Karyawan",
"Add Employee":"Tambah Data",
"Category Employee":"Kategori",
"Select Category":"Pilih Kategori",
"Start Date Join":"Tanggal Bergabung",
"Avatar":"Foto",
"Select Supervisor":"Pilih Supervisor",
"Extra Coverage Area":"Area Jangkauan",
"Select Coverage Area":"Pilih Area",
"Code Employee":"Kode Karyawan",
"Npwp":"NPWP",
"Start Contract":"Tanggal Mulai Kontrak",
"End Contract":"Tanggal Akhir Kontrak",
"Salary Class":"Golongan Gaji",
"Select Category":"Pilih Golongan",
"BPJS No.":"No BPJS",
"Create User":"Buat Akun",
"Employee":"Personel",

"Salary":"Penggajian",
"Allowance":"Tunjangan",
"Add Allowance":"Tambah Tunjangan",
"Allowance Detail":"Rincian Tunjangan",
"Detail":"Rincian",
"Details":"Rincian",
"Add Allowance Detail":"Tambah Rincian",
"Select Allowance":"Pilih Tunjangan",
"Allowance Type":"Tipe Tunjangan",

"Salary Cuts":"Potongan",
"Add Data":"Tambah Data",

"Salary Cuts Detail":"Rincian Potongan",
"Add Salary Cuts Detail":"Tambah Rincian",
"Select Salary Cuts":"Pilih Potongan",
"Salary Cuts Type":"Tipe Potongan",
"Salary Cuts Unit":"Dasar Potongan",

"Attendance":"Kehadiran",
"Holiday":"Hari Libur",
"Add Holiday":"Tambah Hari Libur",
"Work Calendar":"Kalender Kerja",
"First Date":"Tanggal Awal",

"Attendance Type":"Tipe Kehadiran",
"Add Attendance":"Tambah Kehadiran",
"Daily Attendance":"Absensi Harian",
"Clock In":"Jam Masuk",
"Not Have Division":"Tidak ada Divisi",
"Total Attendance":"Total Kehadiran",

"Authorization":"Otorisasi",
"Log Approval":"Persetujuan Log",
"Approval":"Persetujuan",
"Code Transaction":"Kode Transaksi",
"User Request":"Diminta Oleh",
"All Branch":"Semua ASMO",
"Waiting Approval from : " : "Menunggu Persetujuan dari : ",
"Approval Goods Offer":"Harga Beli",
"Approval Memo In":"Memo In",
"Journal Transaction - Memo In":"Jurnal Memo In",
"Approval Memo Out":"Memo Out",
"Journal Transaction - Memo Out":"Jurnal Memo Out",
"Approval Purchase Order":"Pesanan Pembelian",
"No Purchase Order":"No Pesanan",
"Store Name":"Depo",
"description":"Keterangan",
"Approval Return Price":"Harga Retur",
"Approval Return Selling":"Retur Penjualan",
"Approval Selling Price":"Harga Jual",
"Approval Taking Goods":"Penerimaan Barang",
"Approval Warehouse Out":"Gudang Keluar",
"Print Goods Receipt":"Reprint Penerimaan",
"Print News Event":"Reprint Berita Acara",
"Reprint Purchase Order":"Reprint Pesanan",
"Please Wait Response from Head Office":"Mohon Menunggu Respon dari Head Office",
"Reload Page":"Muat Ulang",
"Reprint Warehouse In":"Reprint Gudang Masuk",
"Reprint Warehouse Out":"Reprint Gudang Keluar",
"Sales Late After Rest":"Keterlambatan setelah Istirahat",
"Sales Late to Check In":"Keterlambatan Jam Masuk",
"Sales Late to Check Out":"Keterlambatan Jam Keluar",
"Update Data Customer":"Perubahan Pelanggan",
"Status Tax":"Status Pajak",
"Files":"Dokumen",
"Competitor":"Kompetitor",
"  Show" :  "  Tampilkan",

  "January": "Januari",
  "February": "Februari",
  "March": "Maret",
  "April": "April",
  "May": "Mei",
  "June": "Juni",
  "July": "Juli",
  "August": "Agustus",
  "September": "September",
  "October": "Oktober",
  "November": "November",
  "December": "Desember",

  "Monday": "Senin",
  "Tuesday": "Selasa",
  "Wednesday": "Rabu",
  "Thursday": "Kamis",
  "Friday": "Jumat",
  "Saturday": "Sabtu",
  "Sunday": "Minggu",

  "Mon": "Sen",
  "Tue": "Sel",
  "Wed": "Rab",
  "Thu": "Kam",
  "Fri": "Jum",
  "Sat": "Sab",
  "Sun": "Min",
  "Cash Accounting":"Kas",
  "Bank Account must be fill":"Akun bank tidak boloeh kosong",
  "INCOMING":"Masuk",
  "OUT":"Keluar",

  "Data Taking Order Not Found"  : "Data BPPB Tidak Ditemukan",
  "Ledger must be fill":"Buku Besar Harus di pilih",
  "Start Date must be fill":"Periode Awal Harus di pilih",
  "End Date must be fill":"Periode Akhir Harus di pilih",
  "Change Sales":"Ubah sales",
  "Type Period":"Tipe Periode",
  "By Date":"Periode tanggal",
  "By Period":"Periode minggu",
};
export default ID;
